/**
 * 購入内容確認画面のエラーメッセージ定義
 * エラー識別子およびcard_info_error_typeに応じたユーザー向けメッセージを返す
 */

// カード登録エラーメッセージ
const SAVE_CARD_ERROR_MESSAGES = {
  token_error: 'カード情報の処理に失敗しました。カード情報を再度入力してください。',
  not_registered: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  temporary_error: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  system_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  unknown_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  fraudulent_registration: '不正な操作が検出されました。お問い合わせください。',
  card_info: 'カード情報が正しくありません。カード情報をご確認ください。',
}

// 決済エラーメッセージ
const PURCHASE_ERROR_MESSAGES = {
  token_error: 'カード情報の処理に失敗しました。カード情報を再度入力してください。',
  not_registered: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  temporary_error: '決済システムで一時的な問題が発生しています。時間をおいて再度お試しください。',
  system_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  unknown_error: '決済システムでエラーが発生しました。問題が続く場合はお問い合わせください。',
  coin_add: 'コインの付与に失敗しました。お問い合わせください。',
  card_info: 'カード情報が正しくありません。カード情報をご確認ください。',
}

// card_info_error_type別のエラーメッセージ
const CARD_INFO_ERROR_TYPE_MESSAGES = {
  card_info_invalid: 'カード情報に誤りがあります。入力内容をご確認ください。',
  card_limit: 'ご利用限度額を超えています。ご利用限度額をご確認いただくか、別のカードをお試しください。',
  card_unavailable: 'このカードはご利用いただけません。別のカードをお試しください。',
  card_system: 'カード会社のシステムで一時的な問題が発生しています。時間をおいて再度お試しください。',
}

const DEFAULT_ERROR_MESSAGE = '決済処理に失敗しました。時間をおいて再度お試しください。'

/**
 * カード登録用: エラー識別子とcard_info_error_typeからエラーメッセージを取得
 * @param {string} errorIdentifier - APIから返されるエラー識別子
 * @param {string|null} cardInfoErrorType - card_info_error_type（card_infoエラー時のみ）
 * @returns {string} ユーザー向けエラーメッセージ
 */
export const getSaveCardErrorMessage = (errorIdentifier, cardInfoErrorType = null) => {
  // card_infoエラーでcard_info_error_typeがある場合は詳細メッセージを返す
  if (errorIdentifier === 'card_info' && cardInfoErrorType) {
    return CARD_INFO_ERROR_TYPE_MESSAGES[cardInfoErrorType] || SAVE_CARD_ERROR_MESSAGES.card_info
  }

  return SAVE_CARD_ERROR_MESSAGES[errorIdentifier] || DEFAULT_ERROR_MESSAGE
}

/**
 * 決済用: エラー識別子とcard_info_error_typeからエラーメッセージを取得
 * @param {string} errorIdentifier - APIから返されるエラー識別子
 * @param {string|null} cardInfoErrorType - card_info_error_type（card_infoエラー時のみ）
 * @returns {string} ユーザー向けエラーメッセージ
 */
export const getPurchaseErrorMessage = (errorIdentifier, cardInfoErrorType = null) => {
  // card_infoエラーでcard_info_error_typeがある場合は詳細メッセージを返す
  if (errorIdentifier === 'card_info' && cardInfoErrorType) {
    return CARD_INFO_ERROR_TYPE_MESSAGES[cardInfoErrorType] || PURCHASE_ERROR_MESSAGES.card_info
  }

  return PURCHASE_ERROR_MESSAGES[errorIdentifier] || DEFAULT_ERROR_MESSAGE
}
